import {
  initializeFirebase,
  getFirebaseAnalytics,
  logEvent,
  getString,
  setUserProperties,
  getAnalytics
} from './javascript-fire-base.js';

const sections = {
  "2.0": [
    "reseller-hero",
    "reseller-stats",
    "reseller-at-a-glance",
    "reseller-earning-potential",
    "reseller-how-program-works",
    "reseller-benefits",
    "reseller-great-partner",
    "reseller-why-program-stands-out",
    "reseller-what-partners-are-saying",
    "faq",
    "contact"
  ],
  "1.0": [
    "reseller-hero-b",
    "reseller-how-program-works-b",
    "reseller-how-program-works-b-2",
    "reseller-benefits-b",
    "contact-b",
  ],
  "all": [
    "horizontal-green-bar",
  ]
}

async function initializeResellerPageLayout() {
  try {
    const { firebaseApp, firebaseRemoteConfig } = await initializeFirebase();

    const activePageVersion = getString(firebaseRemoteConfig, "reseller_page_version");
    // const activePageVersion = "2.0"; // Hardcoded for testing purposes

    setUserProperties(getAnalytics(firebaseApp), {
      "firebase_exp_abt_9": activePageVersion
    });

    Object.keys(sections).forEach(version => {
      if (version !== activePageVersion && version !== "all") {
        sections[version].forEach(section => {
          const sectionElement = document.getElementById(section);
          if (sectionElement) {
            sectionElement.style.display = "none";
          }
        });
      }
    });

    sections[activePageVersion].forEach(section => {
      const sectionElement = document.getElementById(section);
      if (sectionElement) {
        sectionElement.style.opacity = "1";
      }
    });

    sections["all"].forEach(section => {
      const sectionElement = document.getElementById(section);
      if (sectionElement) {
        sectionElement.style.opacity = "1";
      }
    });

    window.scrollTo(0, 0);
    return activePageVersion;
  } catch (error) {
    console.error("Error fetching remote config, using defaults:", error);

    const latestVersion = Object.keys(sections).filter(version => version !== "all").sort().pop();

    Object.keys(sections).forEach(version => {
      if (version !== latestVersion && version !== "all") {
        sections[version].forEach(section => {
          const sectionElement = document.getElementById(section);
          if (sectionElement) {
            sectionElement.style.display = "none";
          }
        });
      }
    });

    sections[latestVersion].forEach(section => {
      const sectionElement = document.getElementById(section);
      if (sectionElement) {
        sectionElement.style.opacity = "1";
      }
    });

    sections["all"].forEach(section => {
      const sectionElement = document.getElementById(section);
      if (sectionElement) {
        sectionElement.style.opacity = "1";
      }
    });

    window.scrollTo(0, 0);
    return latestVersion;
  }
}

document.addEventListener('DOMContentLoaded', async () => {
  const primaryCTAs = document.querySelectorAll('.primary-cta');

  const activePageVersion = await initializeResellerPageLayout();

  primaryCTAs.forEach(cta => {
    cta.addEventListener('click', () => {
      logEvent(getFirebaseAnalytics(), 'primary_cta_click', {
        source: 'reseller_page',
        page_version: activePageVersion
      });
    });
  });
})
